import React, { Component } from 'react';
import { connect } from 'react-redux';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import FormUp from 'grommet/components/icons/base/FormUp';
import FormDown from 'grommet/components/icons/base/FormDown';
import FormCheckmark from 'grommet/components/icons/base/FormCheckmark';
import Serverconfig from './Serverconfig';
import CheckBox from 'grommet/components/CheckBox';
import Layer from 'grommet/components/Layer';
import Spinning from 'grommet/components/icons/Spinning';
import CircleInformation from 'grommet/components/icons/base/CircleInformation';
import Paragraph from 'grommet/components/Paragraph';
import ReactTooltip from 'react-tooltip';
import { fetchServerList, defaultfetchServerList, fetchNodeQty, getosdisklist } from '../Redux/actions/epaActions';
import { errorValidataion } from '../../State/actions/sessions';
import { updateMasterandGatewayServices } from '../commonLogic';
import * as Constants from '../Redux/action_types/EPAConstants';
//import Anchor from 'grommet/components/Anchor';
let onBluedatachangebox = false;
let ProcorDiskValue = null;
let StroageNodeQtyCall = false;
let DatabaseDatadiskChange = false;
let defaultNodevalueChange = true;
var HDFS_Change = ""
var Scality_Change = ""
var Weka_Change = ""
var Hive_Change = ""
var Cassandra_change = ""
var Impala_Change = ""
var HBase_Change = ""
var SparkStreaming_Change = ""
var Kafka_Change = ""
var Flink_Change = ""
var Storm_Change = ""
var Yarn_Change = ""
var Spark_Change = ""
var TensorFlow_Change = ""
var Py_Torch_Change = ""
var MiNifi_Change = ""
let serverValue,datadisktypValue;
var inputs = {
    function: "",
    service: "",
}
let isMixedStorageConfiguration = "";
let AIConfigtypevalue = "";
const AI = "AI";
let GPUvalue = "";
//let EeasuredisabledHDFS=false
class Accordion extends Component {
    constructor() {
        super();
        this.state = {
            title: '',
            toggle: '',
            isSelected: '',
            isBlueDataSelected: '',
            isErasureChkboxHDFSSelected: false,
            isErasureChkboxMAPRSelected: false
        }
        this.onBlueDataChange = this.onBlueDataChange.bind(this)
        this.onToggle = this.onToggle.bind(this)
        this.onAddServiceChange = this.onAddServiceChange.bind(this);
        // this.isDefault=this.isDefault.bind(this);
    }
    onAddServiceChange(e) {
        // var flag=false;
        // if(this.state.isSelected===false){
        //     flag=true;
        // }
        //this.props.SelectedService.value=this.props.title;
        var _isSelected;

        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
            if (val['@Type'] === this.props.type) {
                if (Array.isArray(val.Service)) {
                  
                    val.Service.filter((service) => {
                        if (service['@Type'] === this.props.title) {

                            if (service['@Selected'] === true || service['@Selected'] === "true") {
                                _isSelected = false;
                                service['@Selected'] = "false"
                            } else {
                                _isSelected = true;
                                service['@Selected'] = Constants.tRUE_
                                if (service['@Type'] === Constants.DATA_LAKE && service.Inputs['@Type'] === Constants.RAW_) {
                                    service.Inputs['@ErasureCoding'] = Constants.fALSE_;
                                    // EeasuredisabledHDFS=true;
                                }
                            }
                        }
                    })

                } else {
                    if (val.Service['@Selected'] === true || val.Service['@Selected'] === "true") {
                        _isSelected = false;
                        val.Service['@Selected'] = "false"
                    }
                    else {
                        _isSelected = true;
                        val.Service['@Selected'] = "true"
                    }
                }
            }
        })
        var inputs = {
            function: this.props.type,
            service: this.props.title,
        }

        // this.props.OnFetchServerList(inputs);
        let pushservice = true;
        if (this.props.defaultSizerWorkload.serversList.length == 0) {
            this.props.OnFetchServerList(inputs);
        }
        else {
            this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
                if (ServiceName.serviceName === this.props.title) {
                    pushservice = false
                }
            })
            if (pushservice) {
                this.props.OnFetchServerList(inputs);
            }
        }
        ///////
        let AddServiceLayer = true;
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
            if (Array.isArray(val.Service)) {
                val.Service.filter((service) => {
                    if (service['@Selected'] === "true" && (val['@Type'] !=="Gateway Node" && val['@Type'] !=="Master Node")) {
                        AddServiceLayer = false;

                    }
                })

            } else {
                if (val.Service['@Selected'] === "true" && (val['@Type'] !=="Gateway Node" && val['@Type'] !=="Master Node")) {
                    AddServiceLayer = false;
                }
            }
        })
        if (AddServiceLayer) {
            let value = {
                isError: true, errorMsg: '    Please select atleast one Service '
            }
            this.props.updateError(value);
        }
        else {
             if(this.props.GlobalErr.isError){
            let value = {
                isError: false, errorMsg: ''
            }
             this.props.updateError(value);
        }
            // let value = {
            //     isError: false, errorMsg: ''
            // }
        }
       // this.props.updateError(value);
        ///////  

        //}
        updateMasterandGatewayServices(this.props.workload);
        if( _isSelected ){
        var Inputs={};
        let flagHDFS = false;
        if (!this.state.isErasureChkboxHDFSSelected || this.state.isErasureChkboxHDFSSelected === "false") {
            flagHDFS = true
        }
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {

            if (val['@Type'] === this.props.type) {
                if (Array.isArray(val.Service)) {
                    val.Service.filter((service) => {
                        if (service['@Type'] === this.props.title) {
                            if (service['@Selected'] === Constants.tRUE_) {
                                if (service['@Type'] === Constants.DATA_LAKE) {
                                    service.Inputs['@ErasureCoding'] = flagHDFS.toString();


                                    Inputs = {
                                        "strFunc": this.props.type,
                                        "strService": this.props.title,
                                        "Server": service.Hardware['@Server'],
                                        "dRawCapacity": parseFloat(service.Inputs['@Capacity']),
                                        "strDataDisk": service.Hardware['@DataDisk'],
                                        "strCapacityType": service.Inputs['@Type'],
                                        "dReplication": parseFloat(service.Inputs['@Replication']),
                                        "dCompression": parseFloat(service.Inputs['@Compression']),
                                        "dOverhead": parseFloat(service.Inputs['@OverHead']),
                                        "bErasureCode": service.Inputs['@ErasureCoding'],
                                        //"bErasureCode":this.props.defaultSizerWorkload.ErasureCodingChkd,
                                        "dData": parseFloat(service.Inputs['@ErasureData']),
                                        "dParity": parseFloat(service.Inputs['@ErasureParity']),
                                        "iDiskQty": parseFloat(service.Hardware['@DiskQty'])
                                    }
                                }
                            }
                        }
                    })
                }
            }
        })
        this.resetChangesToEmpty()
        datadisktypValue = e.value;
        StroageNodeQtyCall = true;
        if (this.props.type === "Analytics" || this.props.type === "Database") {
          ProcorDiskValue = "Disk Changed";
          DatabaseDatadiskChange = true;
        }
        defaultNodevalueChange = true
        this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
              this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                if (val.Service['@Type'] === this.props.title) {
                    if (val.Service['@Selected'] === Constants.tRUE_) {
                        datadisktypValue =  val.Service.Hardware['@DataDisk'];
                      serverValue = val.Service.Hardware['@Server'];
                    }
                }
            })
        })
    
        var OSInputs = {
          "strFunction": this.props.type,
        "strService": this.props.title,
        "strServer": serverValue,
        "strDataDisk": datadisktypValue,
        }
        this.props.OnGetOSDiskList(OSInputs);
        this.onWorkloadUpdate(this.props.type, this.props.title, "datadisktypValue");
        }
        this.setState({ isSelected: _isSelected });
        //this.setState({})
    }
    onToggle() {
        var temp = this.state.toggle;
        this.setState({ toggle: !temp })
    }
    onisErasureChkboxMAPRSelectedChange(e) {
        let flagMAPR = false;
        if (!this.state.isErasureChkboxMAPRSelected || this.state.isErasureChkboxMAPRSelected === "false") {
            flagMAPR = true
        }
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
            if (val['@Type'] === this.props.type) {
                if (Array.isArray(val.Service)) {
                    val.Service.filter((service) => {
                        if (service['@Type'] === this.props.title) {
                            if (service['@Selected'] === "true") {
                                if (service['@Type'] === "MapR and MapR-EC") {
                                    service.Inputs['@ErasureCoding'] = flagMAPR.toString();
                                }
                            }
                        }
                    })
                }
            }
        })
        this.setState({ isErasureChkboxMAPRSelected: flagMAPR })
    }
    onisErasureChkboxHDFSSelectedChange(e) {
        var Inputs = {}
        let flagHDFS = false;
        if (!this.state.isErasureChkboxHDFSSelected || this.state.isErasureChkboxHDFSSelected === "false") {
            flagHDFS = true
        }

        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {

            if (val['@Type'] === this.props.type) {
                if (Array.isArray(val.Service)) {
                    val.Service.filter((service) => {
                        if (service['@Type'] === this.props.title) {
                            if (service['@Selected'] === Constants.tRUE_) {
                                if (service['@Type'] === Constants.DATA_LAKE) {
                                    service.Inputs['@ErasureCoding'] = flagHDFS.toString();


                                    Inputs = {
                                        "strFunc": this.props.type,
                                        "strService": this.props.title,
                                        "Server": service.Hardware['@Server'],
                                        "dRawCapacity": parseFloat(service.Inputs['@Capacity']),
                                        "strDataDisk": service.Hardware['@DataDisk'],
                                        "strCapacityType": service.Inputs['@Type'],
                                        "dReplication": parseFloat(service.Inputs['@Replication']),
                                        "dCompression": parseFloat(service.Inputs['@Compression']),
                                        "dOverhead": parseFloat(service.Inputs['@OverHead']),
                                        "bErasureCode": service.Inputs['@ErasureCoding'],
                                        //"bErasureCode":this.props.defaultSizerWorkload.ErasureCodingChkd,
                                        "dData": parseFloat(service.Inputs['@ErasureData']),
                                        "dParity": parseFloat(service.Inputs['@ErasureParity']),
                                        "iDiskQty": parseFloat(service.Hardware['@DiskQty'])
                                    }
                                }
                            }
                        }
                    })
                }
            }
        })
        this.props.OnFetchNodeQty(Inputs);
        this.setState({ isErasureChkboxHDFSSelected: flagHDFS })
    }
    resetChangesToEmpty = () => {
        HDFS_Change = ""
        Scality_Change = ""
        Weka_Change = ""
        Hive_Change = ""
        Cassandra_change = ""
        Impala_Change = ""
        HBase_Change = ""
        SparkStreaming_Change = ""
        Kafka_Change = ""
        Flink_Change = ""
        Storm_Change = ""
        Yarn_Change = ""
        Spark_Change = ""
        TensorFlow_Change = ""
        Py_Torch_Change = ""
        MiNifi_Change = ""
      }
      onWorkloadUpdate = (type, title, tag) =>{
        //this.props.SelectedService.value=title
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
          if (val['@Type'] === type) {
            if (Array.isArray(val.Service)) {
              val.Service.filter((service) => {
                if (service['@Type'] === title) {
                  // service['@Selected']=this.props.isSelected;
                  let disksQtyinpayload = [];
                  let existingDrivesArray = [];
                  let Arg0, Arg1, Arg2
                  let earasure = false
                  let Databasedrives = [];
                  Databasedrives.push(service.Hardware['@DataDisk']);
                  let DatabaseandAnalyticsDiskQtyChange = "";
                  if (service['@Selected'] === "true") {
                      if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
                        isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0]["@mixedStorage"]
                        existingDrivesArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks
                      } else {
                        isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service["@mixedStorage"]
                        existingDrivesArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks
                      }
                  if(isMixedStorageConfiguration === "True") {
                    disksQtyinpayload = service.DataDisks
                  }
                    let Inputs = {};
                      switch (this.props.type) {
                        case 'Storage':
                          if (this.props.title === "Weka") {
                            Inputs = {
                              "strFunc": this.props.type,
                              "strService": this.props.title,
                              "SKUInfo": service.Inputs['@SKUInfo'],
                              "strServer": service.Hardware['@Server'],
                              "strDriveClass": service.Inputs['@DriveClass'],
                              "PeakReadIO": parseFloat(service.Inputs['@PeakReadIOPS']),
                              "PeakWriteIO": parseFloat(service.Inputs['@PeakWriteIOPS']),
                              "PeakReadBW": parseFloat(service.Inputs['@PeakReadBW']),
                              "PeakWriteBW": parseFloat(service.Inputs['@PeakWriteBW']),
                              "dUsableCapacity": parseFloat(service.Inputs['@Capacity']),
                            }
                          } else if (this.props.title === "Scality") {
                            Inputs = {
                              "strFunc": this.props.type,
                              "strService": this.props.title,
                              "isGreenLake": service.Inputs['@GreenLake'],
                              "strServer": service.Hardware['@Server'],
                              "strDataDisk": service.Hardware['@DataDisk'],
                              "Drives": disksQtyinpayload,
                              "iDiskQty": parseFloat(service.Hardware['@DiskQty']),
                              "dUsableCapacity": parseFloat(service.Inputs['@Capacity']),
                              "dStoragePerc": parseFloat(service.Inputs['@StoragePerc']),
                              "strSite": service.Inputs['@NoOfSites'],
                              "strReplication": service.Inputs['@Replication']
                            }
                          }
                          else {
                            Inputs = {
                              "strFunc": this.props.type,
                              "strService": this.props.title,
                              "Server": service.Hardware['@Server'],
                              "dRawCapacity": parseFloat(service.Inputs['@Capacity']),
                              "strDataDisk": service.Hardware['@DataDisk'],
                              "Drives": disksQtyinpayload,
                              "strCapacityType": service.Inputs['@Type'],
                              "dReplication": parseFloat(service.Inputs['@Replication']),
                              "dCompression": parseFloat(service.Inputs['@Compression']),
                              "dOverhead": parseFloat(service.Inputs['@OverHead']),
                              "bErasureCode": earasure,
                              //"bErasureCode":this.props.defaultSizerWorkload.ErasureCodingChkd,
                              "dData": parseFloat(service.Inputs['@ErasureData']),
                              "dParity": parseFloat(service.Inputs['@ErasureParity']),
                              "iDiskQty": parseFloat(service.Hardware['@DiskQty'])
                            }
                          }
                          break;
                        case 'Streaming':
                          Inputs = {
                            "strFunc": this.props.type,
                            "strService": this.props.title,
                            "Server": service.Hardware['@Server'],
                            "dMessPerSec": parseFloat(service.Inputs['@MessagesPerSec'])
                          }
                          break;
                        case 'Database':
                          Inputs = {
                            "strFunc": this.props.type,
                            "strService": this.props.title,
                            "Server": service.Hardware['@Server'],
                            "SelectedDisk": service.Hardware['@DataDisk'],
                            "Drives": disksQtyinpayload,
                            "DBSize": parseFloat(service.Inputs['@Capacity']),
                            "dNodeStorage": parseFloat(service.Inputs['@NodeStorage']),
                            "dQueriesPerMinute": parseFloat(service.Inputs['@OpsPerSec']),
                            "lstDataDrives": Databasedrives,
                            //"lstDataDrives":service.Hardware['@DataDisk'],
                            "iDataDiskQty": parseInt(service.Hardware['@DiskQty'], 10),
                            "bIsDiskChanged": true,
                            "strProcessor": service.Hardware['@Proc'],
                            "strCompChanged": ProcorDiskValue
                            //"iDataDiskQtyChange":DatabaseandAnalyticsDiskQtyChange
                          }
                          break;
                        case 'AI':
                          Inputs = {
                            "strFunc": this.props.type,
                            "strService": this.props.title,
                            "strServer": service.Hardware['@Server'],
                            "strConfigType": AIConfigtypevalue,
                            "iGPUQty": "",
                            "dImagesPerSec": parseFloat(service.Inputs['@ImagesPerSec']),
                            "strGPUSelected": service.Inputs['@GPU']
                          }
                          break;
                        case 'Analytics':
                          Inputs = {
                            "strFunc": this.props.type,
                            "strService": this.props.title,
                            "strConfigType": service.Inputs['@ConfigType'],
                            "arg0": Arg0,
                            "arg1": Arg1,
                            "arg2": Arg2,
                            "strServer": service.Hardware['@Server'],
                            "strDataDisk": service.Hardware['@DataDisk'],
                            "Drives": disksQtyinpayload,
                            "dNodeStorage": parseFloat(service.Inputs['@NodeStorage']),
                            "lstDataDrives": Databasedrives,
                            //"lstDataDrives":service.Hardware['@DataDisk'],
                            "iDataDiskQty": parseInt(service.Hardware['@DiskQty'], 10),
                            "bIsDiskChanged": DatabaseandAnalyticsDiskQtyChange,
                            "strMemory": service.Hardware['@Memory'],
                            "strProcessor": service.Hardware['@Proc'],
                            "strCompChanged": ProcorDiskValue
                            //"iDataDiskQtyChange":DatabaseandAnalyticsDiskQtyChange
    
                          }
                          break;
                        }
                        this.props.OnFetchNodeQty(Inputs);
                      }
                    }
                  })
                  }
        }
      })
    }
    onBlueDataChange() {
       // onBluedatachangebox = true
        // if(this.state.isBlueDataSelected){
        //     this.state.isBlueDataSelected=false;
        // }else{
        //     this.state.isBlueDataSelected=true;
        // }
        
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                    if (val['@Type'] === this.props.type) {
                        if (Array.isArray(val.Service)) {
                            val.Service.filter((service) => {
                                if (service['@Type'] === this.props.title) {
                                    if (service['@Selected'] === "true") {
                                        onBluedatachangebox = true
                                    } else {
                                       onBluedatachangebox = false
                                    }

                                }
                            })
                        }
                        else {
                            if (val.Service['@Type'] === this.props.title) {
                                if (val.Service['@Selected'] === "true") {
                                    onBluedatachangebox = true
                                } else {
                                    onBluedatachangebox = false
                                }
                            }
                        }

                    }
                })
        this.setState({})
    }
    componentDidMount() {

        var _toggle = this.props.expanded;
        var _isSelected
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
            if (val['@Type'] === this.props.type) {
                if (Array.isArray(val.Service)) {
                    val.Service.filter((service) => {
                        if (service['@Type'] === this.props.title) {

                            if (service['@Selected'] === true || service['@Selected'] === "true") {
                                _isSelected = true;
                            } else {
                                _isSelected = false;
                            }
                        }
                    })

                }
                else {
                    if (val.Service['@Type'] === this.props.title) {
                        if (val.Service['@Selected'] === true || val.Service['@Selected'] === "true") {
                            _isSelected = true;
                        }
                        else {
                            _isSelected = false;
                        }
                    }
                }
            }
        })



        //  var Iputs={
        //      DefaultData:[
        //         {
        //         "function": "Storage",
        //         "service": "HDFS"
        //         },
        //         {
        //         "function": "Database",
        //         "service": "Hive"
        //         },
        //          {
        //         "function": "Streaming",
        //         "service": "Spark Streaming"
        //         },
        //          {
        //         "function": "Analytics",
        //         "service": "Yarn"
        //         },
        //          {
        //         "function": "AI",
        //         "service": "Tensorflow"
        //         },
        //          {
        //         "function": "IoT",
        //         "service": "MiNifi"
        //         }

        //     ]
        //  }

        //  if(this.props.defaultSizerWorkload.serversList.length == 0)
        //  {
        //     this.props.OnDefaultFetchServerList(Iputs);
        //  }
        this.setState({ toggle: _toggle });
        this.setState({ isSelected: _isSelected });
        //this.setState({})
    }
    componentWillReceiveProps(nextProps, nextState) {
        if (nextProps.title !== this.props.title) {

            var _toggle = nextProps.expanded;
            var _isSelected
            // if (nextProps.isDefault==='true') {
            //     _isSelected = true;
            // }
            // else
            //     _isSelected = false;


            this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                if (val['@Type'] === nextProps.type) {
                    if (Array.isArray(val.Service)) {
                        val.Service.filter((service) => {
                            if (service['@Type'] === nextProps.title) {

                                if (service['@Selected'] === true || service['@Selected'] === "true") {
                                    _isSelected = true;
                                } else {
                                    _isSelected = false;
                                }
                            }
                        })

                    }
                    else {
                        if (val.Service['@Type'] === nextProps.title) {
                            if (val.Service['@Selected'] === true || val.Service['@Selected'] === "true") {
                                _isSelected = true;
                            } else {
                                _isSelected = false;
                            }
                        }

                    }
                }
            })

            this.setState({ toggle: _toggle });
            this.setState({ isSelected: _isSelected });
        }

    }

    render() {
        /* Changes by Vinay, added this.props.workload != null && this.props.workload != undefined condition , for CID:10644*/
        if ( this.props.workload != null && this.props.workload != undefined && this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
            var LoadindData = "";
            if (this.props.isLoading) {
                LoadindData = <Layer style={{ zIndex: '500 !important' }}>
                    <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
                        <Spinning size='small' style={{ color: "#fff" }} />
                        <Heading tag='h5' margin='none' style={{ color: "#fff" }}>Please wait while fetching the data.</Heading>
                    </Box>
                </Layer>
            }
            inputs.function = this.props.tabtitle;
            inputs.service = this.props.title;
            if (this.props.workload != null && this.props.workload != undefined) {

                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                    if (val['@Type'] === this.props.type) {
                        if (Array.isArray(val.Service)) {
                            val.Service.filter((service) => {
                                if (service['@Type'] === this.props.title) {
                                    if (service['@Selected'] === "true") {
                                        if (onBluedatachangebox) {
                                            if (this.state.isBlueDataSelected) {
                                                this.state.isBlueDataSelected = false;
                                                service.Inputs['@BlueData'] = "false"

                                            } else {
                                                this.state.isBlueDataSelected = true;
                                                service.Inputs['@BlueData'] = "true"
                                            }
                                            onBluedatachangebox = false
                                        } else {
                                            if (service.Inputs['@BlueData'] === "true") {
                                                this.state.isBlueDataSelected = true;
                                            } else {
                                                this.state.isBlueDataSelected = false;
                                            }
                                        }
                                        if (service['@Type'] === Constants.DATA_LAKE) {
                                            this.state.isErasureChkboxHDFSSelected = ((/true/i).test(service.Inputs['@ErasureCoding']));
                                        } else if (service['@Type'] === "MapR and MapR-EC") {
                                            this.state.isErasureChkboxMAPRSelected = ((/true/i).test(service.Inputs['@ErasureCoding']));
                                        }
                                        //this.state.isBlueDataSelected=service.Storage['@BlueData'];

                                    } else {
                                        this.state.isBlueDataSelected = false;
                                        if (service['@Type'] === Constants.DATA_LAKE) {
                                            this.state.isErasureChkboxHDFSSelected = false;
                                        } else if (service['@Type'] === "MapR and MapR-EC") {
                                            this.state.isErasureChkboxMAPRSelected = false;
                                        }


                                    }

                                }
                            })
                        }
                        else {
                            if (val.Service['@Type'] === this.props.title) {
                                // if(this.state.isSelected===true){
                                //      val.Service['@Selected']="true";
                                // }else{
                                //      val.Service['@Selected']="false";
                                // }

                                if (val.Service['@Selected'] === "true") {
                                    if (onBluedatachangebox) {
                                        if (this.state.isBlueDataSelected) {
                                            this.state.isBlueDataSelected = false;
                                            val.Service.Inputs['@BlueData'] = "false"

                                        } else {
                                            this.state.isBlueDataSelected = true;
                                            val.Service.Inputs['@BlueData'] = "true"
                                        }
                                        onBluedatachangebox = false
                                    } else {
                                        if (val.Service.Inputs['@BlueData'] === "true") {
                                            this.state.isBlueDataSelected = true;
                                        } else {
                                            this.state.isBlueDataSelected = false;
                                        }
                                    }
                                } else {
                                    this.state.isBlueDataSelected = false;

                                }


                            }
                        }

                    }
                })
                //        this.props. workload.UserInputs.Environments.Functions.Function.filter((val)=>{
                //       if(val['@Type']=== this.props.type)
                //       {
                //          if(Array.isArray(val.Service))
                //         {
                //              val.Service.filter((service)=>{
                //               if(service['@Type']===this.props.title)
                //               {
                //                 //service['@Selected']=this.props.isSelected;
                //                 if( service['@Selected']){
                //                   service['@Selected']="true"
                //                 }else{
                //                   service['@Selected']="false"
                //                 }
                //               }
                //              })

                //             }
                //           }
                //   })

            }
            let ErasureChkboxHDFS = ""
            let ErasureChkboxMAPR = ""
            let EeasuredisabledHDFS = false
            let EeasuredisabledMAPR = false
            //this.props.defaultSizerWorkload.StorageCapacitytype.HDFS==="Raw"
            if (this.props.title === Constants.DATA_LAKE && this.props.workload.UserInputs.Environments.Functions.Function[0]["Service"][0]['Inputs']['@Type'] === "Raw") {
                EeasuredisabledHDFS = true;
                this.state.isErasureChkboxHDFSSelected = false
            }
            if (this.props.title === "MapR and MapR-EC" && this.props.defaultSizerWorkload.StorageCapacitytype.MAPR === "Raw") {
                EeasuredisabledMAPR = true;
                this.state.isErasureChkboxMAPRSelected = false
            }
            if (this.props.title === Constants.DATA_LAKE) {
                ErasureChkboxHDFS = <CheckBox label='Erasure Coding' disabled={EeasuredisabledHDFS} checked={this.state.isErasureChkboxHDFSSelected} onChange={(e) => this.onisErasureChkboxHDFSSelectedChange(e)} />
            }
            if (this.props.title === "MapR and MapR-EC") {
                ErasureChkboxMAPR = <CheckBox label='Erasure Coding' disabled={EeasuredisabledMAPR} checked={this.state.isErasureChkboxMAPRSelected} onChange={(e) => this.onisErasureChkboxMAPRSelectedChange(e)} />
            }
            let BlueDataChkbox = ''
            if (/*this.props.type !== 'IoT' &&*/ this.props.title !== 'Scality' && this.props.title !== 'Weka')
            // if (this.props.type !== 'IoT')
            {
                let BludeDataOptiondisable = true
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                    if (val['@Type'] === this.props.type) {
                        if (Array.isArray(val.Service)) {
                            val.Service.filter((service) => {
                                if (service['@Type'] === this.props.title) {
                                    if (service['@Selected'] === "true") {
                                        if (Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(service.Hardware['@Server']) !== -1 || service.Hardware['@Server'].indexOf(Constants.E910) !== -1 || service.Hardware['@Server'].indexOf(Constants.EL4000) !== -1 ) {
                                            BludeDataOptiondisable = false
                                        }
                                        else {
                                            BludeDataOptiondisable = true
                                            this.state.isBlueDataSelected = false
                                            service.Inputs['@BlueData'] = "false"
                                        }
                                    } else {

                                    }
                                }
                            })

                        }
                        else {
                            if(Constants.HPECP_SUPPORTED_SERVERS_LIST.indexOf(val.Service.Hardware['@Server']) !== -1 || val.Service.Hardware['@ServerName'].indexOf(Constants.E910) !== -1 || val.Service.Hardware['@ServerName'].indexOf(Constants.EL4000) !== -1 ) {
                                BludeDataOptiondisable = false;
                            }
                            else {
                                BludeDataOptiondisable = true
                                this.state.isBlueDataSelected = false
                                val.Service.Inputs['@BlueData'] = "false"
                            }
                        }
                    }
                })

                BlueDataChkbox = <CheckBox label={<Box direction='row' style={{ height: '25px' }}><Paragraph style={{ margin: "3px", }}>HPE Ezmeral CP Option</Paragraph>
                    {<Box><CircleInformation data-tip={Constants.HPE_Ezmeral_CP_Option} data-for={Constants.EZMERAL_CP_OPTION} colorIndex="accent-3" style={{ width: "20px", height: "20px", margin: '3px' }}/>
                    <ReactTooltip place="left" multiline={true} type="dark" effect="solid" id={Constants.EZMERAL_CP_OPTION} /></Box>
                    }</Box>}
                    disabled={BludeDataOptiondisable} checked={this.state.isBlueDataSelected} onChange={this.onBlueDataChange.bind(this)} />
                // BlueDataChkbox = <CheckBox label='BlueData Option' disabled={BludeDataOptiondisable}checked={this.state.isBlueDataSelected} onChange={this.onBlueDataChange.bind(this)} />
            }
            var bodycontent = '';
            if (this.state.toggle) {
                bodycontent = <Box direction='row' pad='small' colorIndex='light-1' >
                    <Serverconfig supportedList={this.props.servers} isSelected={this.state.isSelected} OSListChanged={this.state.isSelected} type={this.props.type} title={this.props.title} erasureHDFS={this.state.isErasureChkboxHDFSSelected} erasureMAPR={this.state.isErasureChkboxMAPRSelected} />
                    {
                        <Box style={{ height: "50%" }} pad={{ between: 'small' }} >
                            <CheckBox checked={this.state.isSelected} label='Add Service' onChange={this.onAddServiceChange}
                                //     () => {
                                //     var temp = this.state.isSelected;
                                // enter={{ "animation": "slide-down", "duration": 200, "delay": 0 }} 
                                //     if(temp)
                                //     {                                        
                                //     this.props.OnFetchServerList({                                    
                                //                     function:this.props.type,
                                //                     service:this.props.title                                                           
                                //                     });
                                //     }
                                //     this.setState({ isSelected: !temp });
                                // } }   
                                />
                            {ErasureChkboxHDFS}
                            {ErasureChkboxMAPR}
                            {BlueDataChkbox}

                        </Box>

                    }

                </Box>
            }

        }
        //BlueData Licenses 
    if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
                let EnableEPICandAI = false
               
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                    if (Array.isArray(val.Service)) {
                        val.Service.filter((services) => {
                            if (services["@Selected"] === "true") {
                                if (services.Inputs["@BlueData"] == "true") {
                                    EnableEPICandAI = true;
                                }
                            }
                        })
                    }
                    else {
                        if ( val.Service["@Selected"] === "true") {
                            if ( val.Service.Inputs !== undefined && val.Service.Inputs["@BlueData"] == "true") {
                                EnableEPICandAI = true;
                            }
                        }
                    }
                })
                if (!EnableEPICandAI) {
                    if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined && Array.isArray( this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License) ){
                    this.props.workload.UserInputs.Environments.HadoopServices['Installation']="false"
                    let hpecpLicense = this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_CONTAINER_PLATFORM);
                    if (hpecpLicense) {
                        hpecpLicense['@Description'] = Constants.NONE_;
                        hpecpLicense['@IsSelected'] = Constants.fALSE_;
                    }
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@Description'] = Constants.NONE_;
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.BLUEDATA_AI)['@IsSelected'] = Constants.fALSE_;
                    this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] = "false"
                    this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text'] = "false"
                    this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text'] = "false"
                    this.props.workload.UserInputs.Environments.HadoopServices['Deployment'] = "false"
                    }
                }
            }

        return (
            <Box colorIndex='unknown' style={{ padding: '5px' }} >
                <Box direction='row' style={{ padding: '5px' }} justify='between' onClick={this.onToggle} >
                     <Box id={this.props.id}  direction='row' pad={{ between: 'small' }} >
                        {this.state.toggle ? <FormUp size='small' /> : <FormDown size='small' />}
                        <Heading tag='h4' margin='none'strong={true}  style={{ fontSize: '15px' }}> {this.props.title} </Heading>
                    </Box>
                  {/* <Box direction='row' pad={{ between: 'small' }} >
                        {this.state.toggle ? <FormUp size='small' /> : <FormDown size='small' />}
                        <Anchor id={this.props.id} strong={true}  label={this.props.title} style={{ fontSize: '15px' }} />
                    </Box>*/}
                    <Box direction='row'>
                        {this.state.isSelected ?
                            <FormCheckmark colorIndex='brand' /> : ''
                        }
                    </Box>
                </Box>
                {LoadindData}
                {bodycontent}

            </Box>
        );
    }
}
const mapStateToProps = (state) => {
    return {

        workload: state.sizerWorkload.workload,
        defaultSizerWorkload: state.sizerWorkload,
        isLoading: state.sizerWorkload.isLoading,
        //SelectedService:state.sizerWorkload.title,
        // SelectedService:state.sessions.activeSession.title,
          GlobalErr: state.sessions.activeSession.globalError,
        //Functions:state.sizerWorkload.workload.WorkLoad.UserInputs.Environments.Functions,
        // activeSession: state.sessions.activeSession,
        //supportedList:state.sizerWorkload.supportedList,
        //isLoading:state.sizerWorkload.isLoading,
        //sessionsDefaults:state.sessions.sessionDefaults    
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        OnFetchServerList: (value) => {
            dispatch(fetchServerList(value));
        },
        OnDefaultFetchServerList: (value) => {
            dispatch(defaultfetchServerList(value));
        },
        OnFetchNodeQty: (value) => {
            dispatch(fetchNodeQty(value));
        },
        OnGetOSDiskList: (value) => {
          dispatch(getosdisklist(value));
        },
        updateError: (errorMsg) => {
            dispatch(errorValidataion(errorMsg));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Accordion);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/Accordion.js